<template>
  <div class="grid grid-cols-12 gap-6">
    <div class="col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6">
      <!-- BEGIN: Offence Cards -->
      <div class="col-span-12 mt-4">
        <div class="intro-y flex items-center h-10">
          <h2 class="text-lg font-medium truncate mr-5">Data Portal</h2>
          <a
            href="#"
            class="ml-auto flex text-theme-1 dark:text-theme-10"
            @click="
              () => {
                this.$router.go();
              }
            "
          >
            <RefreshCcwIcon class="w-4 h-4 mr-3" /> Reload Data
          </a>
        </div>
        <div class="grid grid-cols-12 gap-6 mt-5">
          <offence-card
            v-for="(offence, key) in offences"
            :key="key"
            :title="offence.name"
            :count="offence.cases_count"
            :percentage="Math.abs(offence.mnth_on_mnth)"
            :increase="offence.mnth_on_mnth > 0"
            :type-id="offence.id"
          >
          </offence-card>
          <div
            v-show="offences.length > 0"
            class="col-span-12 mt-2 text-lg text-right"
          >
            <router-link to="/offences-cards">
              View all
            </router-link>
          </div>
        </div>
      </div>
      <!-- END: Offence Cards -->
      <!-- BEGIN: Case History -->
      <div class="col-span-12 lg:col-span-8">
        <CasesHistoryChart :height="273" />
      </div>
      <!-- END: Case History -->
      <!-- BEGIN: Cases by Court -->
      <div class="col-span-12 lg:col-span-4">
        <div class="intro-y flex items-center h-10">
          <h2 class="text-lg font-medium truncate mr-3">Cases by Court</h2>
          <PieChartIcon class="report-box__icon text-theme-1" />
        </div>
        <div class="intro-y box p-5 mt-3">
          <CasesCourtChart :height="210" />
        </div>
      </div>
      <!-- END: Cases by Court -->
      <!-- BEGIN: Charts -->
      <div class="col-span-12 grid grid-cols-12 gap-6 mt-4">
        <!-- BEGIN: Cases by Status -->
        <div class="col-span-12 lg:col-span-4 xl:col-span-4 mt-4">
          <div class="intro-y flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-3">Cases by Status</h2>
            <PieChartIcon class="report-box__icon text-theme-6" />
          </div>
          <div class="intro-y box p-5 mt-3">
            <CasesStatusChart :height="210" />
          </div>
        </div>
        <!-- END: Cases by Status -->
        <!-- BEGIN: Courts' Decisions -->
        <div class="col-span-12 md:col-span-6 lg:col-span-4 mt-4">
          <div class="intro-y flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-3">Courts' Decisions</h2>
            <BarChart2Icon class="report-box__icon text-theme-9" />
          </div>
          <div class="intro-y box p-5 mt-3">
            <CasesDecisionChart :height="210" :show-percentages="true" />
          </div>
        </div>
        <!-- END: Courts' Decision -->
        <!-- BEGIN: Cases Duration -->
        <div class="col-span-12 md:col-span-6 lg:col-span-4 mt-4">
          <div class="intro-y flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-3">Cases Duration</h2>
            <BarChart2Icon class="report-box__icon text-theme-1" />
          </div>
          <div class="intro-y box p-5 mt-3">
            <CasesDurationChart :height="210" :show-percentages="true" />
          </div>
        </div>
        <!-- END: Cases Duration -->
      </div>
      <!--  END: Charts  -->
      <!-- BEGIN: Cases by States  -->
      <div class="col-span-12 mt-6">
        <div class="intro-y flex items-center h-10">
          <h2 class="text-lg font-medium truncate mr-3">Cases by States</h2>
          <BarChartIcon class="report-box__icon text-theme-6" />
        </div>
        <div class="intro-y overflow-auto lg:overflow-visible mt-3">
          <!-- <StatesCases /> -->
          <StackedStatesCases />
        </div>
      </div>
      <!-- END: Cases by States  -->
      <!-- BEGIN: Comparison Charts -->
      <div class="col-span-12 grid grid-cols-12 gap-6">
        <!-- BEGIN: Cases By Sector -->
        <div class="col-span-12 md:col-span-6 mt-4">
          <div class="intro-y flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-3">Cases by Sector</h2>
            <BarChart2Icon class="report-box__icon text-theme-9" />
          </div>
          <div class="intro-y box p-5 mt-3">
            <CasesSectorChart :height="275" :show-percentages="false" />
          </div>
        </div>
        <!-- END: Cases By Sector -->
        <!-- BEGIN: Cases By Agency -->
        <div class="col-span-12 md:col-span-6 mt-4">
          <div class="intro-y flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-3">Cases by Agency</h2>
            <BarChart2Icon class="report-box__icon text-theme-1" />
          </div>
          <div class="intro-y box p-5 mt-3">
            <CasesAgencyChart :height="285" :show-percentages="true" />
          </div>
        </div>
        <!-- END: Years & Cases -->
        <!-- BEGIN: Case History -->
        <div class="col-span-12 lg:col-span-6 mt-4">
          <CasesYearChart :height="425" />
        </div>
        <!-- END: Years & Cases -->
        <!-- BEGIN: Top 5 States by Status -->
        <div class="col-span-12 lg:col-span-6 mt-4">
          <div class="intro-y flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-3">
              Top 5 States by Cases
            </h2>
            <BarChart2Icon class="report-box__icon text-theme-1" />
          </div>
          <div class="intro-y box p-5 mt-3">
            <CasesStateChart :height="350" :count="5" />
          </div>
        </div>
        <!-- END: Top 5 States by Status -->
      </div>
      <!--  END: Comparison Charts -->
      <!-- BEGIN: ACJA/L Compliance -->
      <!-- <div class="col-span-12 lg:col-span-4 mt-4">
        <div class="intro-y flex items-center h-10">
          <h2 class="text-lg font-medium truncate mr-3">ACJA/L Compliance</h2>
          <PieChartIcon class="report-box__icon text-theme-6" />
        </div>
        <div class="intro-y box p-5 mt-3">
          <CasesComplianceChart :height="210" />
        </div>
      </div> -->
      <!-- END: ACJA/L Compliance -->
      <!-- BEGIN: Cases Location -->
      <!-- <div class="col-span-12 lg:col-span-8 xl:col-span-8 mt-4"> -->
      <div class="col-span-12 mt-4 min-h-[500px]">
        <CourtsMap />
      </div>
      <!-- END: Cases Location -->
      <!-- BEGIN: Recent Cases -->
      <div class="col-span-12 mt-6">
        <div class="intro-y flex items-center h-10">
          <h2 class="text-lg font-medium truncate mr-3">Recent Cases</h2>
          <BellIcon class="report-box__icon text-theme-6" />
        </div>
        <div class="intro-y overflow-auto lg:overflow-visible">
          <table class="table table-report sm:mt-2">
            <thead>
              <tr>
                <th class="whitespace-no-wrap">TITLE</th>
                <th class="whitespace-no-wrap">OFFENCE</th>
                <th class="whitespace-no-wrap">COURT/JUDGE</th>
                <th class="whitespace-no-wrap">AGENCY</th>
                <th class="whitespace-no-wrap">STATUS</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(caseFile, caseKey) in recent_cases"
                :key="caseKey"
                class="intro-x"
              >
                <td class="w-60">
                  {{ caseFile.name }}
                </td>
                <td class="">{{ caseFile.case_type.name }}</td>
                <td class="">
                  <a href="" class="font-medium whitespace-no-wrap">
                    {{ `${caseFile.court.name}, ${caseFile.court.state.name}` }}
                  </a>
                  <div class="text-gray-600 text-xs whitespace-no-wrap">
                    {{ caseFile.judges[0].name }}
                  </div>
                </td>
                <td>{{ caseFile.agency.shortname }}</td>
                <td class="w-24">
                  <div
                    class="flex items-center"
                    :class="{
                      'text-theme-9': caseFile.case_status == 'Decided',
                      'text-theme-6': caseFile.case_status != 'Decided'
                    }"
                  >
                    {{ caseFile.case_status }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- END: Recent Cases -->
    </div>
    <div
      class="col-span-12 xxl:col-span-3 xxl:border-l border-theme-5 -mb-10 pb-10"
    >
      <div class="xxl:pl-6 grid grid-cols-12 gap-6">
        <!-- BEGIN: High Profile Cases -->
        <div
          class="col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-6 xxl:mt-8"
        >
          <!-- <div class="col-span-12 xl:col-span-4 mt-6"> -->
          <div class="intro-y flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-3">
              High Profile Cases <small>(days)</small>
            </h2>
            <StarIcon class="report-box__icon text-theme-6" />
          </div>
          <div class="mt-3">
            <template v-if="profile_cases.length > 0">
              <div
                v-for="(caseFile, caseKey) in profile_cases"
                :key="caseKey"
                class="intro-y"
              >
                <div class="box px-4 py-4 mb-3 flex items-center zoom-in">
                  <div class="ml-2 mr-auto w-2/3">
                    <div class="font-medium case-title">
                      <a
                        :href="host_url + '/cases/' + caseFile.slug"
                        class="font-medium"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {{ caseFile.name }}
                      </a>
                    </div>
                    <div class="text-gray-600 text-xs">
                      {{ caseFile.date_of_arraignment }}
                    </div>
                  </div>
                  <div>
                    <div
                      class="w-12 py-1 px-2 rounded-full text-xs text-center bg-theme-6 text-white cursor-pointer font-medium"
                    >
                      {{ caseFile.duration_in_days }}
                    </div>
                    <div class="text-gray-600 text-xs text-center">
                      {{ caseFile.case_status }}
                    </div>
                  </div>
                </div>
              </div>
              <router-link
                :to="{ name: 'high-profile-cases' }"
                tag="a"
                class="intro-x w-full block text-center rounded-md py-3 border border-dotted border-theme-15 dark:border-dark-5 text-theme-16 dark:text-gray-600"
                >View More</router-link
              >
            </template>
            <div v-else class="intro-y">
              <div class="box px-4 py-4 mb-3 flex items-center zoom-in">
                <div class="ml-1 mr-1">
                  <div class="font-small">No Cases Recorded!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: High Profile Cases -->
        <!-- BEGIN: Never Ending Cases -->
        <div
          class="col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-6 xxl:mt-8"
        >
          <div class="intro-x flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-3">
              Never Ending Cases
            </h2>
            <ClockIcon class="report-box__icon text-theme-6" />
          </div>
          <div class="mt-3">
            <template v-if="never_ending_cases.length > 0">
              <div
                v-for="(caseFile, caseKey) in never_ending_cases"
                :key="caseKey"
                class="intro-x"
              >
                <div class="box px-5 py-3 mb-3 flex items-center zoom-in">
                  <div class="ml-2 mr-auto w-2/3">
                    <div class="font-medium">
                      <a
                        :href="host_url + '/cases/' + caseFile.slug"
                        class="font-medium"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {{ caseFile.defendants[0].name }}
                        <small
                          v-show="caseFile.defendants[0].designation"
                          class="text-gray-600 text-xs"
                        >
                          ({{ caseFile.defendants[0].designation }})
                        </small>
                      </a>
                    </div>
                    <div class="text-gray-600 text-xs">
                      {{ caseFile.date_of_arraignment }}
                    </div>
                  </div>
                  <div class="text-theme-6">
                    <div class="w-12 py-1 px-2 text-center">
                      {{ caseFile.duration_in_days }}
                    </div>
                    <div class="text-center">
                      days
                    </div>
                  </div>
                </div>
              </div>
              <router-link
                :to="{ name: 'never-ending-cases' }"
                tag="a"
                class="intro-x w-full block text-center rounded-md py-3 border border-dotted border-theme-15 dark:border-dark-5 text-theme-16 dark:text-gray-600"
                >View More</router-link
              >
            </template>
            <div v-else class="intro-y">
              <div class="box px-4 py-4 mb-3 flex items-center zoom-in">
                <div class="ml-1 mr-1">
                  <div class="font-small">No Cases Recorded!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Never Ending Cases -->
        <!-- BEGIN: Judges' Cases -->
        <div
          class="col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-6 xxl:mt-8"
        >
          <div class="intro-x flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-3">Judges' Cases</h2>
            <UserIcon class="report-box__icon text-theme-9" />
          </div>
          <div class="mt-3">
            <template v-if="judges_cases.length > 0">
              <div
                v-for="(judge, judgeKey) in judges_cases"
                :key="judgeKey"
                class="intro-x"
              >
                <div class="box px-5 py-3 mb-3 flex items-center zoom-in">
                  <div class="ml-4 mr-auto">
                    <div class="font-medium">
                      <router-link
                        :to="{ name: 'judge-cases', params: { id: judge.id } }"
                        tag="a"
                      >
                        {{ judge.name }}
                      </router-link>
                    </div>
                    <div class="text-gray-600 text-xs">
                      {{ judge.designation }}
                    </div>
                  </div>
                  <div class="text-theme-9">
                    <div class="w-12 py-1 px-2 text-center">
                      {{ judge.cases_count }}
                    </div>
                    <div class="text-center">
                      cases
                    </div>
                  </div>
                </div>
              </div>
              <router-link
                :to="{ name: 'judges-cases' }"
                tag="a"
                class="intro-x w-full block text-center rounded-md py-3 border border-dotted border-theme-15 dark:border-dark-5 text-theme-16 dark:text-gray-600"
                >View More</router-link
              >
            </template>
            <div v-else class="intro-y">
              <div class="box px-4 py-4 mb-3 flex items-center zoom-in">
                <div class="ml-1 mr-1">
                  <div class="font-small">No Cases Recorded!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Judges' Cases -->
        <!-- BEGIN: ACJA/L Notes -->
        <div
          class="col-span-12 md:col-span-6 xl:col-span-12 xxl:col-span-12 xl:col-start-auto xl:row-start-auto xxl:col-start-auto xxl:row-start-auto mt-6"
        >
          <div class="intro-x flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-3">
              ACJA/L <br />Compliance Notes
            </h2>
            <BookIcon class="report-box__icon text-theme-9 mr-auto" />
            <button
              class="slick-navigator button px-2 border border-gray-400 dark:border-dark-5 flex items-center text-gray-700 dark:text-gray-600 mr-2"
              @click="prevNotes"
            >
              <ChevronLeftIcon class="w-4 h-4" />
            </button>
            <button
              class="slick-navigator button px-2 border border-gray-400 dark:border-dark-5 flex items-center text-gray-700 dark:text-gray-600"
              @click="nextNotes"
            >
              <ChevronRightIcon class="w-4 h-4" />
            </button>
          </div>
          <div class="mt-3 intro-x">
            <div class="box zoom-in">
              <VueSlickCarousel ref="acjal-notes" v-bind="carousel_settings">
                <div v-for="(note, key) in acja_notes" :key="key" class="p-5">
                  <div class="text-base font-medium truncate">
                    {{ note.title }}
                  </div>
                  <div class="text-gray-600 text-justify mt-1">
                    {{ note.content }}
                  </div>
                </div>
              </VueSlickCarousel>
            </div>
          </div>
        </div>
        <!-- END: ACJA/L Notes -->
      </div>
    </div>
  </div>
</template>

<script>
import CasesDecisionChart from "@/components/CasesDecisionChart";
import CasesSectorChart from "@/components/CasesSectorChart";
import CasesHistoryChart from "@/components/CasesHistoryChart";
import CasesDurationChart from "@/components/CasesDurationChart";
import CasesAgencyChart from "@/components/CasesAgencyChart";
import CasesStatusChart from "@/components/CasesStatusChart";
import CasesCourtChart from "@/components/CasesCourtChart";
import CasesYearChart from "@/components/CasesYearChart";
// import CasesComplianceChart from "@/components/CasesComplianceChart";
import CourtsMap from "@/components/CourtsMap";
import OffenceCard from "@/components/OffenceCard";
// import StatesCases from "@/components/StatesCases";
import StackedStatesCases from "@/components/StackedStatesCases";
import CasesStateChart from "@/components/CasesStateChart";
import VueSlickCarousel from "vue-slick-carousel";
import axios from "axios";

export default {
  components: {
    CasesHistoryChart,
    CasesDecisionChart,
    CasesDurationChart,
    CasesSectorChart,
    CasesAgencyChart,
    CasesStatusChart,
    CasesCourtChart,
    CasesYearChart,
    // CasesComplianceChart,
    CourtsMap,
    CasesStateChart,
    "offence-card": OffenceCard,
    // StatesCases,
    StackedStatesCases,
    VueSlickCarousel
  },
  data() {
    return {
      host_url: process.env.VUE_APP_CCD_CLIENT_URL,
      offences: [],
      profile_cases: [],
      recent_cases: [],
      never_ending_cases: [],
      judges_cases: [],
      acja_notes: this.$store.state.notes.notes,
      carousel_settings: {
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 15000,
        pauseOnDotsHover: true,
        pauseOnFocus: true,
        pauseOnHover: true
      }
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.populate();
      }
    }
  },
  mounted() {
    this.populate();
  },
  methods: {
    prevNotes() {
      this.$refs["acjal-notes"].prev();
    },
    nextNotes() {
      this.$refs["acjal-notes"].next();
    },
    populate() {
      this.getTopOffences();
      this.getProfileCases();
      this.getRecentCases();
      this.getNeverEndingCases();
      this.getJudgesCases();
    },
    getTopOffences() {
      axios
        .get(`${window.host}/api/offences/4`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.offences = Object.keys(response.data).map(
              i => response.data[i]
            );
            this.offences.sort((a, b) => {
              return b.cases_count - a.cases_count;
            });
          }
        });
    },
    getProfileCases() {
      axios
        .get(`${window.host}/api/profile-cases/4`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.profile_cases = response.data;
          }
        });
    },
    getRecentCases() {
      axios
        .get(`${window.host}/api/summary-cases/6`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.recent_cases = response.data;
          }
        });
    },
    getNeverEndingCases() {
      axios
        .get(`${window.host}/api/never-ending-cases/5`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.never_ending_cases = response.data;
          }
        });
    },
    getJudgesCases() {
      axios
        .get(`${window.host}/api/judges-cases/5`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.judges_cases = response.data;
          }
        });
    }
  }
};
</script>

<style>
.case-title {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
